import { fieldValidators, StorageSchema } from './schema';

export function isValidStorageKey(storageKey: string): storageKey is keyof StorageSchema {
  const eligableKeys = Object.keys(fieldValidators);
  const isValid = eligableKeys.includes(storageKey);
  return isValid;
}
